export default __webpack_public_path__ + "static/media/icon-individual-gray.1c1bd7cb.svg";